export default {
    getWorker(state) {
        return state.data;
    },
    getError: state => {
        return state.error;
    },
}